import React, { useEffect, useState } from "react";
import ImageGallery from "react-image-gallery";
import GalleryNextIcon from "@components/Svg/GalleryNextIcon";
import GalleryPrevIcon from "@components/Svg/GalleryPrevIcon";
import { PrimaryButton } from "@components/UI/Buttons/PrimaryButton/PrimaryButton";
import { numberWithSpaces } from "@src/utils/formatUtils";
import { OfferIcon } from "@features/catalog";
import { ProductPriceUsd } from "@features/product/product-price-usd";
import { ContactButton } from "@features/profile";
import { getCurrencySymbol, toRelativeTime } from "@shared/lib/utils";
import { VerticalCatalogCardMapProps } from "./types";
import classes from "../vertical-catalog-card/vertical-catalog-card.module.scss";

const VerticalCatalogCardMap = (props: VerticalCatalogCardMapProps) => {
    const offer = props.data;
    const ITEM_PROPS = [
        { label: "Трансмиссия", value: offer.prepTransmission },
        { label: "Привод", value: offer.prepDriveType },
        { label: "Кузов", value: offer.prepBodyType },
        { label: "Цвет", value: offer.prepColor }
    ];
    const [isDetailedInfoVisible, setIsDetailedInfoVisible] = useState(false);
    useEffect(() => {
        const isNoAdditionalData = !props.data.url && !props.data.prepPhone;
        setIsDetailedInfoVisible(isNoAdditionalData);
    }, [props.data]);
    const galleryRef = React.useRef(null);
    const images = props.data.imagesList.map((image) => {
        return {
            original: image.small
        };
    });
    const offerAddress = [offer.city, offer.address].filter(Boolean).join(", ");
    const priceInCurrency = `${numberWithSpaces(props.data.price)} ${getCurrencySymbol(props.data.sourceId)}`;

    return (
        <div className={classes.VerticalCatalogCardMap}>
            <div className={`${classes.Gallery} CatalogCardGallery`}>
                <ImageGallery
                    disableKeyDown={true}
                    ref={galleryRef}
                    additionalClass={classes.GalleryCont}
                    items={images}
                    infinite={true}
                    showThumbnails={false}
                    showFullscreenButton={false}
                    slideDuration={200}
                    showPlayButton={false}
                    renderRightNav={(onClick) => {
                        // @ts-ignore
                        return <GalleryNextIcon className={classes.Next} onClick={onClick} />;
                    }}
                    renderLeftNav={(onClick) => {
                        // @ts-ignore
                        return <GalleryPrevIcon className={classes.Prev} onClick={onClick} />;
                    }}
                />
            </div>

            <div className={classes.VerticalCardContent}>
                <div className={classes.VerticalCardNameContainer}>
                    <a
                        onClick={(event) => {
                            event.preventDefault();
                            window.open(`/product/${props.data.id}`, "_blank");
                        }}
                        className={classes.VerticalCardName}
                        title={props.data.title}
                        href="#"
                    >
                        {props.data.title}
                    </a>
                </div>

                <div className={classes.Price}>
                    <span className={classes.Price__source}>{priceInCurrency}</span>
                    <ProductPriceUsd
                        className={classes.Price__usd}
                        priceUsd={offer.priceUsd}
                        price={offer.price}
                        sourceId={offer.sourceId}
                    />
                </div>

                <div className={classes.Tags}>
                    <div>{offer.year} г</div>
                    {offer.mileage && <div>{numberWithSpaces(offer.mileage)} км</div>}
                </div>

                <div className={classes.Divider}></div>

                <div className={classes.Props}>
                    {ITEM_PROPS.map((item, index) => {
                        return (
                            <div className={classes.Prop} key={index}>
                                <div className={classes.PropLabel}>{item.label}</div>
                                <div className={classes.PropValue}>{item.value}</div>
                            </div>
                        );
                    })}
                </div>

                <div className={classes.Divider}></div>

                <div className={classes.Location}>
                    <svg
                        width="8"
                        height="8"
                        viewBox="0 0 8 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="4" cy="4" r="4" fill="#5B8149" />
                    </svg>
                    {offerAddress}
                </div>

                <div className={classes.Divider}></div>

                <div className={classes.MapButtonsContainer}>
                    {!isDetailedInfoVisible && (
                        <PrimaryButton
                            type="Large"
                            onClick={() => {
                                setIsDetailedInfoVisible(true);
                            }}
                            content={"Подробнее"}
                        />
                    )}

                    {isDetailedInfoVisible && (
                        <div className={classes.DetailedInfo}>
                            {props.data.prepPhone && <ContactButton phone={props.data.prepPhone} />}
                            {props.data.url && (
                                <PrimaryButton
                                    type="Large"
                                    onClick={() => {
                                        window.open(props.data.url, "_blank");
                                    }}
                                    content={"Перейти на сайт объявления"}
                                />
                            )}
                            <a
                                className={classes.LinkBtn}
                                href="#"
                                onClick={(event) => {
                                    event.preventDefault();
                                    window.open(`/product/${props.data.id}`, "_blank");
                                }}
                            >
                                Подробнее об автомобиле
                            </a>
                        </div>
                    )}
                </div>

                <div className={classes.Footer}>
                    <OfferIcon className={classes.Footer_icon} sourceId={offer.sourceId} />
                    <div className={classes.UpdatedTime}>{toRelativeTime(offer.createdAt)}</div>
                </div>
            </div>
        </div>
    );
};
export default VerticalCatalogCardMap;